export default "__VITE_ASSET__7fa7207d__"